var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#F3F4F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4416_4516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 58C44.7739 58 49.3523 56.1036 52.7279 52.7279C56.1036 49.3523 58 44.7739 58 40C58 35.2261 56.1036 30.6477 52.7279 27.2721C49.3523 23.8964 44.7739 22 40 22C35.2261 22 30.6477 23.8964 27.2721 27.2721C23.8964 30.6477 22 35.2261 22 40C22 44.7739 23.8964 49.3523 27.2721 52.7279C30.6477 56.1036 35.2261 58 40 58ZM34.3047 34.3047C34.9656 33.6438 36.0344 33.6438 36.6883 34.3047L39.993 37.6094L43.2977 34.3047C43.9586 33.6438 45.0273 33.6438 45.6812 34.3047C46.3352 34.9656 46.3422 36.0344 45.6812 36.6883L42.3766 39.993L45.6812 43.2977C46.3422 43.9586 46.3422 45.0273 45.6812 45.6812C45.0203 46.3352 43.9516 46.3422 43.2977 45.6812L39.993 42.3766L36.6883 45.6812C36.0273 46.3422 34.9586 46.3422 34.3047 45.6812C33.6508 45.0203 33.6438 43.9516 34.3047 43.2977L37.6094 39.993L34.3047 36.6883C33.6438 36.0273 33.6438 34.9586 34.3047 34.3047Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4416_4516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelPayments);
export default __webpack_public_path__ + "static/media/cancel-payments.da1f47fa0084c9ee6b80c5ea1ccbe10c.svg";
export { ForwardRef as ReactComponent };